<template>
  <table>
    <caption>
      <slot></slot>
    </caption>
    <colgroup>
      <col>
      <col span="2">
      <col>
      <col>
      <col>
      <col>
    </colgroup>
    <thead>
      <tr>
        <th rowspan="2">等級</th>
        <th colspan="2"
            class="border-bottom">花朵數量</th>
        <th rowspan="2">花面圓整度</th>
        <th rowspan="2">花序緊密度</th>
        <th rowspan="2">花莖整齊度</th>
        <th rowspan="2">其他條件</th>
      </tr>
      <tr>
        <th>一般品種</th>
        <th>公主品種</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="data in standardData"
          :key="data.level">
        <td>{{ data.level }}</td>
        <td>{{ data.count.general | convertRangeText }}</td>
        <td>{{ data.count.princess | convertRangeText }}</td>
        <td>{{ data.roundness | covertLevelText }}</td>
        <td>{{ data.closeness | covertLevelText }}</td>
        <td>{{ data.tidiness | covertLevelText }}</td>
        <td>{{ data.LimitText }}</td>
      </tr>
      <tr>
        <td colspan="7">註：{{ standardDescription }}</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
  export default {
    name: 'BaseTable',
    props: {
      standard: {
        type: Object,
        required: true,
      },
    },
    computed: {
      standardData() {
        return this.standard.data;
      },
      standardDescription() {
        return this.standard.description;
      },
    },
    filters: {
      // 轉換區間文字
      // 規則為當 max: number min: number max === min  -> max || min
      // 規則為當 max: number min: 0 -> <= max
      // 規則為當 max: number min: number max > min  -> max - min
      // 規則為當 max: "infinity" min: number -> >= min
      convertRangeText(data) {
        let { max, min } = data;
        max = Number(max);
        min = Number(min);

        if (max === min) return max && min;
        else if (min === 0 && max) return `<=${max}`;
        else if (max === Infinity && min) return `>=${min}`;
        else if (max !== Infinity && min) return `${min}-${max}`;
      },
      // 轉換英文等級到中文 : A -> 優 B -> 良 C -> 可
      covertLevelText(data) {
        switch (data) {
          case 'A':
            return '優';
          case 'B':
            return '良';
          case 'C':
            return '可';
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  table {
    width: 100%;
    min-width: 1000px;

    caption {
      padding-left: 6px;
      font-weight: bold;
      caption-side: top;
      color: #393b44;
    }

    col {
      width: 9%;
      &:last-child {
        width: 46%;
      }
    }

    tr {
      &:hover {
        background: #e0ece420;
      }
    }

    th {
      text-align: center;
      color: #393b44;
      background-color: #e0ece4;
      font-weight: normal;
      padding: 0.5em 0.5rem;
    }

    td {
      color: #393b44;
      border: 1px solid #e0ece4;
      font-weight: light;
      padding: 1em 0.5rem;
      &:not(:last-child) {
        text-align: center;
      }
    }

    .border-bottom {
      border-bottom: 1px solid #fff;
    }
  }
</style>